if (window.jQuery) {
$(document).ready(function() {
    function loadMoreStores(el) {
        chkDelay    = '200'; // Amount of time between Checks
        ldMrBtn     = 'load-more';
        ldMrCont    = ldMrBtn+'-container';
        hdCls       = 'hide';
        // Set loop based on screen size
        if (window.innerWidth <= 980) {
            loop = 3;
        } else {
            loop = 5;
        }
        el          = el;
        reset       = false;
        moreButton  = '<div class="'+ldMrCont+' '+hdCls+'"><a href="#" class="'+ldMrBtn+'">Load More</a></div>';
        var chkExist = setInterval(function() {
            chkClass    = $(el);
            exists      = false;
            total       = chkClass.length;
            // If chkClass exists
            if (total) {
                ifExists(el)
            }
        }, chkDelay);
        // // Reset on Resize
        // $(window).resize(function () {
        //     winWidth = $(window).outerWidth();
        //     if (exists==true && winWidth<750 && reset!=false) {
        //         reset = false
        //         setupLoadMoreClasses(el)
        //     } else if (winWidth>=750) {
        //         reset = true;
        //     }
        // })
        function setupLoadMoreButton(el) {
            // Add a Load More Button Container after every $loop
            $(el+':nth-of-type('+loop+'n - 1)').after(moreButton);
        }
        function setupLoadMoreClasses(el) {
            // Hide all but first $loop
            $(el+':nth-of-type(n + '+(loop+1)+')').addClass(hdCls);
            // Hide All Load More Containers
            $('.'+ldMrCont).addClass(hdCls);
            // Show first Load More Container
            $('.'+ldMrCont).first().removeClass(hdCls);
        }
        function ifExists(el) {
            exists = true;
            // Clear checker interval
            clearInterval(chkExist);
            // Check if load more needed
            if (total>loop) {
                setupLoadMoreButton(el)
                setupLoadMoreClasses(el)
                // On Load More Button Click
                $('.'+ldMrBtn).on('click touch', function(e) {
                    e.preventDefault();
                    // Get Load More Parent Container
                    curBtn = $(this).parent();
                    // Show all Elements until next Load More Container
                    curBtn.nextUntil('.'+ldMrCont).removeClass(hdCls);
                    // 1. Hide Clicked Load More Button with jquery
                    // 2. Show the next Load More Container that's :not(hdCls)
                    curBtn.addClass(hdCls).nextAll('.'+ldMrCont+'.'+hdCls).first().removeClass(hdCls);
                })
            }
        }
    }
    mobStrs = '.storepoint-location';
    loadMoreStores(mobStrs)
});
}

(function () {
    document.addEventListener("storepoint:ready", appendScentImage);
    if (window.Storepoint && typeof Storepoint.on === "function") {
        Storepoint.on("load", appendScentImage);
        if (Storepoint._ready) appendScentImage();
    }
})();